export default {
  'receipt.title': '回執信息',
  'receipt.btn.add': '增加回執信息',
  'receipt.btn.import': '導入回執信息',
  'receipt.btn.export': '導出回執信息',
  'receipt.input.placeholder': '請輸入回執信息',
};
